<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-info">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-solid fa-truck"></i>
                                <span>Generare AWB</span>
                            </mat-card-title>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <div class="d-flex justify-content-start m-2 gap-2">
                        <button
                            *ngIf="docData.entity && permissionsService.hasPermission('indoc-module.registratura_documents.operations-posta.awb_generate')"
                            type="button"
                            style="background-color:#00c0ef; border-color: #00acd6; color: #fff; font-size: 12px"
                            class="button-doc" (click)="openAddAWBDialog()">
                            <i class="fa-solid fa-plus add-icon"></i>
                            <span>Adaugă AWB</span>
                        </button>
                    </div>
                    <mat-divider></mat-divider>
                    <table class="table table-condensed table-wrapper-box">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Identificator / Data</th>
                                <th>Creat la</th>
                                <th>Status</th>
                                <th>Acțiuni</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngIf="!docData.awb_documents.length">
                                <td colspan="5" class="text-center">
                                    <strong><i>Lipsă înregistrări</i></strong>
                                </td>
                            </tr>
                            <ng-container *ngIf="docData.awb_documents.length">
                                <ng-container *ngFor="let row of docData.awb_documents; let i = index;">
                                    <tr>
                                        <td>
                                            {{ i + 1 }}
                                        </td>
                                        <td>
                                            {{ row.identificator || 'n/a' }} / {{ row.data_identificator || 'n/a' }}
                                        </td>
                                        <td>
                                            {{ row.created_at | date : "dd.MM.yyyy HH:mm" : "ro" }}
                                        </td>
                                        <td>
                                            <div *ngIf="row.processed === 2 && row.active === 1">
                                                <span class="label color-green">Procesat</span>
                                            </div>
                                            <div *ngIf="row.processed === 3 && row.active === 1">
                                                <span class="label color-red">Eroare procesare</span>
                                            </div>
                                            <div *ngIf="row.processed === 0 && row.active === 1">
                                                <span class="label color-grey">Neprocesat</span>
                                            </div>
                                            <div *ngIf="row.processed === 1 && row.active === 1">
                                                <span class="label color-orange">În procesare</span>
                                            </div>
                                            <div *ngIf="row.active === 0">
                                                <span class="label color-purple">Dezactivat</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="d-flex align-items-center gap-1 flex-wrap">
                                                <button
                                                    *ngIf="row.processed === 2 && row.active === 1 && row.identificator && permissionsService.hasPermission('indoc-module.registratura_documents.operations-posta.awb_download')"
                                                    class="action-btn download" style="font-size: 11px; color: #fff"
                                                    title="Descarcă" (click)="downloadAwb(row.id, row.identificator)">
                                                    <i class="btn-img fa fa-download"></i>
                                                </button>
                                                <button
                                                    *ngIf="row.active !== 0 && row.processed !== 2 && row.processed !== 3 && row.id_document === docData.id_document && permissionsService.hasPermission('indoc-module.registratura_documents.operations-posta.awb_duplicate')"
                                                    class="action-btn allocate" style="font-size: 11px; color: #fff"
                                                    title="Duplică" (click)="duplicateAwb(row.id)">
                                                    <i class="btn-img fa-regular fa-copy"></i>
                                                </button>
                                                <button
                                                    *ngIf="row.active === 1 && row.processed !== 2 && permissionsService.hasPermission('indoc-module.registratura_documents.operations-posta.awb_update')"
                                                    class="action-btn edit" title="Actualizează"
                                                    (click)="openEditAWBDialog(row)">
                                                    <img class="btn-img" src="/assets/icons/edit.svg" alt="edit" />
                                                </button>
                                                <button
                                                    *ngIf="row.active === 1 && row.id_document === docData.id_document && permissionsService.hasPermission('indoc-module.registratura_documents.operations-posta.awb_delete_local')"
                                                    class="action-btn delete" title="Șterge"
                                                    (click)="deleteAwb(row.id)">
                                                    <img class="btn-img" src="../../../../assets/icons/delete.svg"
                                                        alt="delete" />
                                                </button>
                                                <button
                                                    *ngIf="permissionsService.hasPermission('indoc-module.registratura_documents.operations-posta.awb_view')"
                                                    class="action-btn view" title="Vizualizare"
                                                    (click)="openViewAWBDialog(row)">
                                                    <img class="btn-img" src="../../../../assets/icons/view.svg"
                                                        alt="view" />
                                                </button>
                                                <button
                                                    *ngIf="row.active === 1 && row.processed === 2 && row.id_document === docData.id_document && permissionsService.hasPermission('indoc-module.registratura_documents.operations-posta.awb_delete_local_and_external')"
                                                    class="action-btn delete d-flex align-items-center"
                                                    title="Dezactivează" (click)="deleteAwbPosta(row.id)">
                                                    <img class="btn-img" src="../../../../assets/icons/delete.svg"
                                                        alt="delete" />
                                                    <span
                                                        style="margin-top: 2px; font-size: 12px; line-height: 1; color: #fff">AWB</span>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr *ngIf="row.awb_connections.length">
                                        <td colspan="5">
                                            <div class="d-flex flex-row gap-2 flex-wrap">
                                                <span *ngFor="let connection of row.awb_connections; let i = index;"
                                                    [ngClass]="i === 0 ? 'awb-doc-conex-label-main' : 'awb-doc-conex-label-secondary'">
                                                    {{ connection.reg_number }} / {{ connection.reg_date }}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>